import { render } from "./ChartPage.vue?vue&type=template&id=2b1f02c2&scoped=true"
import script from "./ChartPage.vue?vue&type=script&lang=js"
export * from "./ChartPage.vue?vue&type=script&lang=js"

import "./ChartPage.vue?vue&type=style&index=0&id=2b1f02c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1f02c2"]])

export default __exports__